// Libraries
import _ from 'lodash';

// Supermove
import {UserFlowStepModel} from '@supermove/models';

// App
import {DocumentContentJsonFormType} from '@shared/modules/Document/forms/DocumentTemplateVersionForm';
import DocumentContentJson from '@shared/modules/Document/helpers/DocumentContentJson';

export type UserFlowRunStepFormType = {
  userFlowStepId?: string;
  documentContentJson?: string;
};

const convertDocumentTemplateInputToJsonString = (
  documentContentJsonForm: DocumentContentJsonFormType,
) => {
  const documentItems = _.cloneDeep(documentContentJsonForm.documentItems);
  return {documentItems: DocumentContentJson.handleStringifyDocumentItems(documentItems)};
};

const _new = (userFlowStep: UserFlowStepModel): UserFlowRunStepFormType => ({
  userFlowStepId: userFlowStep.id,
  documentContentJson:
    userFlowStep.documentTemplate.activeDocumentTemplateVersion.documentContentJson,
});

const toForm = (userFlowRunStep: UserFlowRunStepFormType): UserFlowRunStepFormType => {
  return {
    userFlowStepId: userFlowRunStep.userFlowStepId,
    documentContentJson: userFlowRunStep.documentContentJson,
  };
};

const toMutation = (userFlowRunStepForm: ReturnType<typeof toForm>) => {
  return {
    userFlowStepId: userFlowRunStepForm.userFlowStepId,
    documentContentJsonForm: userFlowRunStepForm.documentContentJson
      ? convertDocumentTemplateInputToJsonString(
          userFlowRunStepForm.documentContentJson as unknown as DocumentContentJsonFormType,
        )
      : undefined,
  };
};

const UserFlowRunStepForm = {
  new: _new,
  toForm,
  toMutation,
};

export default UserFlowRunStepForm;
